import Modal from "../../../common/ui/modal";
import {useEffect, useState} from "react";
import _ from "lodash";
import {DESIGN_KEY_PREFIX} from "../../constants/design.constant";


const DeleteDesignVariant = ({designVariant, removeDesignVariant}) => {
    const [variantIndex, setVariantIndex] = useState(null);

    useEffect(() => {
        if (designVariant) {
            setVariantIndex(_.parseInt(_.replace(designVariant.key, DESIGN_KEY_PREFIX.VARIANT + '-', '')))
        }
    }, [designVariant]);

    return (
        <>
            <Modal
                showButtonLabel={"Delete"}
                title="Delete Design Variant"
                content={[{
                    text: `Are you sure you wish to delete the below design variant?`,
                    classes: ""
                }, {
                    text: `${designVariant?.name} - #${variantIndex}`,
                    classes: "text-blue font-bold"
                }]}
                confirmButtonLabel="Confirm Delete"
                showIcon={true}
                handleConfirm={() => {
                    removeDesignVariant(designVariant)
                }}
            />
        </>
    )
}

export default DeleteDesignVariant
